export default __webpack_public_path__ + "static/media/icon_request.7fef42ce.svg";